import React, { Component } from "react";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-kit-react/views/docPage.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import Typography from "@material-ui/core/Typography";
import Button from "components/CustomButtons/Button.jsx";
import DocListItem from "components/DocList/DocListItem";
import GlobalValue from "GlobalValue";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import {
  MuiPickersUtilsProvider,
  TimePicker,
  DatePicker
} from "material-ui-pickers";

import axios from "axios";
import EmpList from "views/DocPage/Modal/EmpList.jsx";
import EmpListM from "views/DocPage/Modal/EmpListMulti.jsx";

import SaveAlt from "@material-ui/icons/SaveAlt";
import Dropzone from "react-dropzone";
import {
  insertEdocument,
  btoa,
  _callApiMessage,
  _parceDate
} from "GlobalFunction";
// core components
function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const Today = new Date();
const TodayYear = Today.getFullYear();
const TodayMonth = _parceDate(Today.getMonth() + 1);
const TodayDay = _parceDate(Today.getDate());
class E_Doc00_insert extends Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      openDialog: this.props.openDialog,
      openEmpList: false,
      EDEG1Code: 302,
      EDEG2Code: 0,
      EDStrING1: `${TodayYear}-${TodayMonth}-${TodayDay}`,
      EDStrING2: "",
      EDStrING3: "",
      EDStrING4: "",
      showEmpList: true,
      EDTitle: "",
      fileList: [],
      EJSTCode: "",
      EDText: "",
      EDBigo: "",
      ERSTCodeList: []
    };
  }

  initState = () => {
    this.setState({
      EDEG1Code: 302,
      EDEG2Code: 0,
      EDStrING1: `${TodayYear}-${TodayMonth}-${TodayDay}`,
      EDStrING2: "",
      EDStrING3: "",
      EDStrING4: "",
      showEmpList: true,
      EDTitle: "",
      fileList: [],
      EJSTCode: "",
      EDText: "",
      EDBigo: "",
      ERSTCodeList: [],
      fileUrl: "",
      checkedEmp: undefined,
      ERef: undefined
    });
  };
  handleEmpList = () => {
    this.setState({ showEmpList: false });
  };
  handleChange = e => {
    let nextState = {};
    nextState[e.target.name] = e.target.value;

    this.setState(nextState);
  };
  handleClose = () => {
    this.initState();
    this.props.handleEdocClose();
  };

  handleEdocEmpListClose = () => {
    this.setState({ showEmpList: true });
  };

  addEmp = emp => {
    this.setState({ showEmpList: true, checkedEmp: emp, EJSTCode: emp.STCode });
  };

  addRef = emp => {
    console.log(emp);
    // var ERSTCodeList = emp.map(item => {
    //   return { STCode: item.STCode };
    // });
    // console.log(ERSTCodeList);
    this.setState({ showEmpList: true, ERef: emp, ERSTCodeList: emp });
  };
  handleFileChange = e => {
    // console.log(e.target.value);
    // console.log(e.target.files);
    // console.log(e.target.files[0].webkitRelativePath);
    var fileNameList = [];
    for (let i = 0; i < e.target.files.length; i++) {
      fileNameList.push({ name: e.target.files[i].name });
    }
    // console.log(fileNameList);
    this.setState({
      fileList: e.target.files,
      fileUrl: e.target.value,
      fileNameList
    });
  };

  _checkedItem = (value, text) => {
    if (value === undefined || value === "" || value === null) {
      alert(`${text} 을 확인하여 주세요`);
      return false;
    }
    return true;
  };

  _checkedItemSize = (value, text) => {
    if (value.length === 0) {
      alert(`${text} 을 확인하여 주세요`);
      return false;
    }
    return true;
  };
  handleSubmit = () => {
    const formData = new FormData();
    const filelist = this.state.fileList;
    if (this.state.fileList.length > 0) {
      for (var i = 0; i < filelist.length; i++) {
        var filenameBase64 = btoa(
          encodeURIComponent(filelist[i].name).replace(
            /%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
              return String.fromCharCode("0x" + p1);
            }
          )
        );
        formData.append("upload", filelist[i], filenameBase64);
      }
    }

    var dbinfo = {
      SCDBName: GlobalValue.USER_INFO.SCDBName,
      SCHostIp: GlobalValue.USER_INFO.SCHostIp
    };
    var tempInsertData = insertEdocument;
    tempInsertData.EDTitle = this.state.EDTitle;
    if (!this._checkedItem(this.state.EDTitle, "제목")) return;
    tempInsertData.EDText = this.state.EDText;
    tempInsertData.EDBigo = this.state.EDBigo;
    tempInsertData.EDSTCode = GlobalValue.USER_INFO.SUSTCode;
    tempInsertData.EDEG1Code =
      this.state.EDEG1Code === undefined ? 0 : this.state.EDEG1Code;
    if (!this._checkedItem(this.state.EDEG1Code, "구분")) return;
    tempInsertData.EDEG2Code =
      this.state.EDEG2Code === undefined ? 0 : this.state.EDEG2Code;
    tempInsertData.EDEJSeq = 0; //최초기안 = 0
    tempInsertData.EJSTCode = this.state.EJSTCode; // 최초기안자;
    tempInsertData.EJSignGubun = 1; // 최초기안 = 대기
    tempInsertData.EDLastJoinYN = "N"; // 최초기안 = 대기
    tempInsertData.EJBefJoinSTCode = GlobalValue.USER_INFO.SUSTCode; // 직전 결재권자는 나
    tempInsertData.EJAftJoinSTCode = this.state.EJSTCode; // 직후 결재권자
    if (!this._checkedItemSize(this.state.ERSTCodeList, "받는사람")) return;
    tempInsertData.ERSTCode = this.state.ERSTCodeList; // 참조자들

    // console.log("tempInsertData.EDTimeStamp1", tempInsertData.EDTimeStamp1);

    // console.log("tempInsertData.EDTimeStamp2", tempInsertData.EDTimeStamp1);
    // console.log(tempInsertData);
    // formData.append('upload', filelist);
    formData.append("EDocObj", JSON.stringify(tempInsertData));
    formData.append("DBInfo", JSON.stringify(dbinfo));
    // console.log("formData", tempInsertData);

    axios
      .post(GlobalValue.BASE_URL + "e-doc/new", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data;charset=UTF-8"
        },
        onUploadProgress: progressEvent =>
          console.log("axios", progressEvent.loaded)
      })
      .then(response => {
        // console.log("response", response);
        if (response.status === 200) {
          return response.data;
        } else {
          alert("systemError.. 관리자에게 문의하세요..");
        }
      })
      .then(responseBody => {
        if (responseBody.code === "00") {
          if (responseBody.type === "O") {
            // Navigation.pop("DOC_TAB_STACK");
            // PUSH 전송
            var pushBody = `${GlobalValue.USER_INFO.SUName}님이 등록한 '${
              this.state.EDTitle
            }' 이(가) 발송하였습니다.`;
            var fcmData = {
              title: "전자 문서",
              body: pushBody,
              data: {
                DATA_KEY: "03",
                DATA_GUBUN: "NEW"
              }
            };

            //받는사람들 푸시
            var body = `userList=${JSON.stringify(
              this.state.ERSTCodeList
            )}&fcmData=${JSON.stringify(fcmData)}`;
            console.log("fcm/send/multi", body);
            _callApiMessage("fcm/send/multi", body).then(responsBody => {
              console.log("fcm/send/multi", responsBody);
              alert("전자문서를 발송하였습니다.");
              this.handleClose();
            });
          } else if (responseBody.type === "N") {
            if (responseBody.code === "20") {
              alert("시스템에러.. 관리자에게 문의하세요..");
            }
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  onPreviewDrop = files => {
    this.setState({
      fileList: this.state.fileList.concat(files)
    });
  };
  onPreviewPop = async index => {
    let sliceFile = this.state.fileList;
    sliceFile.splice(index, 1);
    await this.setState({ fileList: sliceFile });
  };
  componentDidMount() {}
  render() {
    const { classes, EDoc, EFile, firstList, ...rest } = this.props;
    return (
      <div>
        <Dialog
          maxWidth="lg"
          open={this.props.openDialog}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          {this.state.showEmpList ? (
            // 로딩 화면 만들어야함
            <div>
              <DialogTitle id="alert-dialog-slide-title">{"내용"}</DialogTitle>
              <div>
                <DialogContent>
                  <DocListItem title="제목">
                    <input
                      type="text"
                      // placeholder="제목을 입력해주세요."
                      size="60"
                      className={classes.docInputText}
                      value={this.state.EDTitle}
                      onChange={this.handleChange}
                      name="EDTitle"
                    />
                  </DocListItem>
                  <DocListItem
                    title="보낸 사람"
                    memo={GlobalValue.USER_INFO.SUName}
                  />
                  <DocListItem title="구분">
                    <Select
                      value={this.state.EDEG1Code}
                      onChange={this.handleChange}
                      inputProps={{
                        name: "EDEG1Code",
                        id: "age-simple"
                      }}
                    >
                      {GlobalValue.EG1Code_2_l.map((item, index) => {
                        return (
                          <MenuItem value={item.value} key={index}>
                            {item.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </DocListItem>
                  <DocListItem title="첨부파일" height="100px">
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Dropzone
                        onDrop={acceptedFiles =>
                          this.onPreviewDrop(acceptedFiles)
                        }
                      >
                        {({ getRootProps, getInputProps }) => (
                          <section>
                            <div
                              {...getRootProps()}
                              style={{
                                height: "50px",
                                border: "1px solid",
                                borderStyle: "dotted"
                              }}
                            >
                              <input {...getInputProps()} />
                              <p>파일 드래그 또는 클릭하여 삽입해주세요.</p>
                            </div>
                          </section>
                        )}
                      </Dropzone>
                      {this.state.fileList.length > 0 && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            overflow: "auto",
                            height: "50px"
                          }}
                        >
                          <ul>
                            {this.state.fileList.map((file, index) => (
                              <li key={index + 100}>
                                <label key={index + 100}>{file.name}</label>
                                <label
                                  type="none"
                                  onClick={() => this.onPreviewPop(index)}
                                  style={{ backgroundColor: "#d1d1d1" }}
                                >
                                  삭제
                                </label>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </DocListItem>
                  {/* <DocListItem title="첨부 파일">
                    <input
                      type="file"
                      onChange={this.handleFileChange}
                      multiple
                    />
                    <label>최대 5개</label>
                  </DocListItem>
                  {this.state.fileList.length > 0 && (
                    <DocListItem title="선택된 파일">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: "50px",
                          overflow: "auto",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        {this.state.fileNameList.map((item, index) => {
                          return <label key={index}>({item.name})</label>;
                        })}
                      </div>
                    </DocListItem>
                  )} */}
                  <DocListItem title="내용">
                    <textarea
                      cols="62"
                      rows="1"
                      // placeholder="내용을 입력해주세요."
                      size="60"
                      className={classes.docInputTextArea}
                      value={this.state.EDText}
                      onChange={this.handleChange}
                      name="EDText"
                    />
                  </DocListItem>

                  <DocListItem title="비고">
                    <input
                      type="text"
                      // placeholder="비고"
                      size="60"
                      className={classes.docInputText}
                      value={this.state.EDBigo}
                      onChange={this.handleChange}
                      name="EDBigo"
                    />
                  </DocListItem>
                </DialogContent>

                <DialogTitle id="alert-dialog-slide-title">
                  {"결재 처리"}
                </DialogTitle>
                <DialogContent>
                  <DocListItem title="받는 사람">
                    <Button
                      onClick={() => this.handleEmpList("M")}
                      color="submit"
                    >
                      {this.state.ERef
                        ? `${this.state.ERef[0].STNameKor} 외 ${this.state.ERef
                            .length - 1}명 `
                        : "받는사람 선택"}
                    </Button>
                  </DocListItem>
                </DialogContent>
              </div>
              <DialogActions>
                <Button onClick={this.handleClose} color="cancel">
                  취소
                </Button>
                <Button onClick={this.handleSubmit} color="submit">
                  전송
                </Button>
              </DialogActions>
            </div>
          ) : (
            <EmpListM
              openDialog={this.state.openEmpList}
              handleEdocEmpListClose={this.handleEdocEmpListClose}
              addRef={this.addRef}
            />
          )}
        </Dialog>
      </div>
    );
  }
}

E_Doc00_insert.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(E_Doc00_insert);
